export default __webpack_public_path__ + "static/media/wallet.43a2793a.jpg";